export const PriceHelper = {
    toPrice(price, currency = "€") {
        return parseFloat(price).toFixed(2).replace('.',',') + currency;
    }
}